import { useState } from "react";
import Account from "../../components/DesignSystem/Trays/Account";
import Drawer, {
	DrawerSlideEnum
} from "../../components/DesignSystem/Trays/Drawer";
import {
	DrawerStateProvider,
	useDrawer
} from "../../components/DesignSystem/Trays/DrawerStateProvider";

function AccountPageContent() {
	const [trayPosition, setTrayPosition] = useState("right");
	const [, setIsVisible] = useState(false);
	const { hideTray, showTray } = useDrawer();

	return (
		<div className="p-8">
			<div className="space-y-4 mb-8">
				<h1 className="text-2xl font-bold">Tray Component Demo</h1>

				<div className="flex space-x-4">
					<button
						onClick={() => {
							setIsVisible((prev) => {
								const rVal = !prev;
								rVal ? showTray() : hideTray();
								return rVal;
							});
						}}
						className="bg-blue-600 text-white px-4 py-2 rounded"
					>
						Open Tray
					</button>

					<select
						value={trayPosition}
						onChange={(e) => setTrayPosition(e.target.value)}
						className="border px-3 py-2 rounded"
					>
						<option value="right">From Right</option>
						<option value="left">From Left</option>
					</select>
				</div>
			</div>
			<Drawer
				position={trayPosition as DrawerSlideEnum}
				className="bg-primary-background"
			>
				<Account />
			</Drawer>
		</div>
	);
}

// Main component just wraps with the provider
function AccountPage() {
	return (
		<DrawerStateProvider>
			<AccountPageContent />
		</DrawerStateProvider>
	);
}

export default AccountPage;
